module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/cta1-7f3fa5e909a4b2fe26cc34ec1c5e6681.png";